import React, { Component } from 'react'
import { TextInput } from '../shared/TextInput'
import _ from 'lodash'

export default class Fees extends Component { 
  render() {
    return (
      <div>
        <label>
          Fees
        </label>
        { this.props.fees && this.props.fees.map( fee => {
          return(
            <TextInput
              inputName={fee['name']}
              label={_.startCase(fee['name'])}
            />
         )
        })
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Settings/Fees.jsx